const STATE_API = '/request_state';

const AUTHENTICATE_API = '/authenticate';
const IS_AUTHENTICATED_API = '/is-authenticated';
const SIGN_OUT_API = '/sign-out';

const STAFF_LIST_GET_API = '/users/staff';
const STAFF_GET_API = '/user/staff/';
const STAFF_DELETE_API = '/user/staff/';
const STAFF_PATCH_API = '/user/staff/';
const STAFF_POST_API = '/user/staff';

const USER_PASSWORD_RECOVERY_LINK_GET_API = '/user/{id}/password-recovery-link';
const USER_RESET_PASSWORD_POST_API = '/reset-password/'; // By an authenticated hash

const DOCUMENTS_GET_API = '/documents';
const DOCUMENT_GET_API = '/document/';
const DOCUMENT_POST_API = '/document';
const DOCUMENT_PATCH_API = '/document/';
const DOCUMENT_DELETE_API = '/document/';

const COMPLAINT_TYPES_GET_API = '/complaint-types';
const COMPLAINT_TYPE_GET_API = '/complaint-type/';
const COMPLAINT_TYPE_POST_API = '/complaint-type';
const COMPLAINT_TYPE_PATCH_API = '/complaint-type/';
const COMPLAINT_TYPE_DELETE_API = '/complaint-type/';

const CLINICS_GET_API = '/clinics';
const CLINIC_GET_API = '/clinic/';
const CLINIC_POST_API = '/clinic';
const CLINIC_PATCH_API = '/clinic/';
const CLINIC_DELETE_API = '/clinic/';

const PATIENTS_GET_API = '/patients';
const PATIENT_GET_API = '/patient/';
const PATIENT_POST_API = '/patient';
const PATIENT_PATCH_API = '/patient/';
const PATIENT_DELETE_API = '/patient/';

const COMPLAINT_CASES_GET_API = '/complaint-cases';
const COMPLAINT_CASE_GET_API = '/complaint-case/';
const COMPLAINT_CASE_FORM_LINK_GET_API = '/complaint-case/{id}/form-link';
const COMPLAINT_CASE_POST_API = '/complaint-case';
const COMPLAINT_CASE_NOTES_PATCH_API = '/complaint-case/{id}/notes';
const COMPLAINT_CASE_FINISH_PATCH_API = '/complaint-case/{id}/finish';
const COMPLAINT_CASE_DELETE_API = '/complaint-case/';

const COMPLAINT_CASE_FORM_DATA_GET_API = '/complaint-case/{id}/form-data';
const COMPLAINT_CASE_FORM_DATA_BY_HASH_GET_API = '/complaint-case/form-data/';
const COMPLAINT_CASE_FORM_POST_API = '/complaint-case/{id}/form';
const COMPLAINT_CASE_FORM_POST_BY_HASH_API = '/complaint-case/form/';

export {
    STATE_API,
    AUTHENTICATE_API,
    IS_AUTHENTICATED_API,
    SIGN_OUT_API,
    STAFF_LIST_GET_API,
    STAFF_GET_API,
    STAFF_DELETE_API,
    STAFF_PATCH_API,
    STAFF_POST_API,
    USER_PASSWORD_RECOVERY_LINK_GET_API,
    USER_RESET_PASSWORD_POST_API,
    DOCUMENTS_GET_API,
    DOCUMENT_GET_API,
    DOCUMENT_POST_API,
    DOCUMENT_PATCH_API,
    DOCUMENT_DELETE_API,
    COMPLAINT_TYPES_GET_API,
    COMPLAINT_TYPE_GET_API,
    COMPLAINT_TYPE_POST_API,
    COMPLAINT_TYPE_PATCH_API,
    COMPLAINT_TYPE_DELETE_API,
    CLINICS_GET_API,
    CLINIC_GET_API,
    CLINIC_POST_API,
    CLINIC_PATCH_API,
    CLINIC_DELETE_API,
    PATIENTS_GET_API,
    PATIENT_GET_API,
    PATIENT_POST_API,
    PATIENT_PATCH_API,
    PATIENT_DELETE_API,
    COMPLAINT_CASES_GET_API,
    COMPLAINT_CASE_GET_API,
    COMPLAINT_CASE_FORM_LINK_GET_API,
    COMPLAINT_CASE_POST_API,
    COMPLAINT_CASE_NOTES_PATCH_API,
    COMPLAINT_CASE_FINISH_PATCH_API,
    COMPLAINT_CASE_DELETE_API,
    COMPLAINT_CASE_FORM_DATA_GET_API,
    COMPLAINT_CASE_FORM_DATA_BY_HASH_GET_API,
    COMPLAINT_CASE_FORM_POST_API,
    COMPLAINT_CASE_FORM_POST_BY_HASH_API,
};